export enum RecombeeRecommendType {
  RECOMMEND_ITEMS_TO_ITEM = 'recommend-items-to-item',
  RECOMMEND_ITEMS_TO_USER = 'recommend-items-to-user',
}